class CartHandler {
  constructor(initialCart = {}, initialCartMetaData = {}) {
    this.cart = initialCart;
    this.cartMetaData = initialCartMetaData;
    this.cartEl =
      document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    //this.freeGiftVariantId = this.freeGiftVariantId;
    this.freeGiftVariantId = 31874798878801;

    this.initializeSubscriptions = this.initializeSubscriptions.bind(this);
    this.initializeSubscriptions();
  }

  initializeSubscriptions() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, async (event) => {
      try {
        const response = await fetch(window.routes.cart_url + '?view=metafields');

        if (!response.ok) {
          //          console.log('response:', response);
          throw new Error(`Network response was not ok: ${response.status} ${response.statusText}`);
        }
        const cartData = await response.json();
        this.cart = cartData.cart;
        const metafieldsData = cartData.metafields;
        this.handleEnrichedCartData(metafieldsData);
      } catch (error) {
        console.error('Error fetching cart metafields:', error);
        const errorElement = document.querySelector('#error-message');
        if (errorElement) {
          errorElement.textContent = 'Failed to update cart information. Please try again.';
        }
      }
    });
  }

  handleEnrichedCartData(enrichedCartData) {
    this.cartMetaData = enrichedCartData;
    // Define the club product ID and tags for easy reference
    const clubProductId = 7232894435409;
    const eligibleTags = ['Club Discount Eligible'];
    const productTags = ['beer', 'seltzer', 'bundle'];

    // Check if the club product is in the cart
    const isClubProductInCart = this.cart.items.some((item) => item.product_id === clubProductId);

    // Filter club products in the cart
    const clubProductsInCart = this.cart.items.filter((item) => {
      const itemMetafields = this.cartMetaData.find((meta) => meta.key === item.key);
      if (itemMetafields?.tags) {
        const tags = itemMetafields.tags;
        return (
          eligibleTags.some((tag) => tags.includes(tag)) &&
          productTags.some((tag) => tags.includes(tag))
        );
      }
      return false;
    });
    // Calculate the total quantity of club products in the cart
    const clubProductsInCartCount = clubProductsInCart.reduce((acc, item) => {
      const itemMetafields = this.cartMetaData.find((meta) => meta.key === item.key);
      if (itemMetafields?.tags.includes('bundle')) {
        return acc + itemMetafields.bundle_size * item.quantity;
      }
      return acc + item.quantity;
    }, 0);
    /*
    const freeGlassVariantId = this.freeGiftVariantId;
    const freeGlass = this.cart.items.find((item) => item.variant_id === freeGlassVariantId);
   */
    // Find promotional free gift by properties (not by variant ID)
    const freeGlass = this.cart.items.find(
      (item) => item.properties?.__free_gift && item.properties?.__trigger === 'new_club_membership'
    );
 

    if (isClubProductInCart && clubProductsInCartCount >= 4 && !freeGlass) {
      this.addFreeGiftToCart();
    }
    if (clubProductsInCartCount < 4 && freeGlass) {
      this.removeFreeGiftFromCart(freeGlass.key);
    }
    if (!isClubProductInCart && freeGlass) {
      this.removeFreeGiftFromCart(freeGlass.key);
    }

    window.__abc = window.__abc || {};
    const ShopifyCartData = {
      cart: this.cart,
      cartMetaFields: this.cartMetaData,
      clubProductsInCartCount,
      clubProductsInCart,
      isClubProductInCart,
    };
    window.__abc.ShopifyCartData = ShopifyCartData;
    // Publish the enriched cart data
    /*
    publish(PUB_SUB_EVENTS.cartUpdateEnriched, {
      source: 'CartHandler',
      data: window.__abc.ShopifyCartData,
    });
    */
    // console.log('cartUpdateEnriched', ShopifyCartData);
    window.dispatchEvent(
      new CustomEvent('cartUpdateEnriched', {
        detail: ShopifyCartData,
        bubbles: true,
        composed: true,
      })
    );
  }

  cleanup() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  removeFreeGiftFromCart(freeGiftItemKey) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: freeGiftItemKey,
        quantity: 0,
      }),
    })
      .then((response) => response.json())
      .then((cart) => {
        // Update internal cart state
        this.cart = cart;
        // Publish the cart update event
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'CartHandler',
          cartData: cart,
        });

        // Optionally, fetch cart meta data again
        //this.fetchCartMetaData();
      })
      .catch((error) => console.error('Error removing free gift:', error));
  }

  addFreeGiftToCart() {
    const FREE_GIFT_VARIANT_ID = this.freeGiftVariantId; // Replace with your free gift variant ID

    // Prepare the request payload
    const toSend = {};
    toSend.items = [
      {
        id: FREE_GIFT_VARIANT_ID,
        quantity: 1,
        properties: {
          __free_gift: true,
          __promo: 'New Club Membership',
          __trigger: 'new_club_membership',
        },
      },
    ];
    // Include sections to render
    toSend.sections = this.cartEl.getSectionsToRender().map((section) => section.id);

    // Prepare the fetch config
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.headers['Content-Type'] = 'application/json';
    config.body = JSON.stringify(toSend);

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          console.error('Error adding free gift:', response);
          return;
        }

        // Update internal cart state
        this.cart = response;
        //console.log({ response });
        // Update the cart UI
        //console.log('this.cartEl', this.cartEl);
        this.cartEl.renderContents(response);

        // Optionally, fetch cart meta data again
        //this.fetchCartMetaData();
      })
      .catch((error) => console.error('Error adding free gift:', error));
  }
}

const initialCartData = window.__abc.ShopifyCartData.cart || {};
const initialCartMetaData = window.__abc.ShopifyCartData.cartMetaFields || {};

const cartHandler = new CartHandler(initialCartData, initialCartMetaData);

// Optional: Clean up when necessary (e.g., when the page unloads)
window.addEventListener('beforeunload', () => {
  cartHandler.cleanup();
});

class ConfirmRemovalModal extends ModalDialog {
  constructor() {
    super();
  }

  handleConfirm(event) {
    const itemKey = event.target.getAttribute('data-item-key');
    if (itemKey) {
      this.removeItemFromCart(itemKey);
    }
  }

  handleCancel() {
    this.hide();
  }

  removeItemFromCart(itemKey) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: itemKey,
        quantity: 0,
      }),
    })
      .then((response) => response.json())
      .then((cart) => {
        this.hide();
        location.reload();
      })
      .catch((error) => {
        console.error('Error removing item from cart:', error);
        this.hide();
      });
  }
}

// Register the custom element
customElements.define('confirm-removal-modal', ConfirmRemovalModal);
